import { gql, useMutation } from '@apollo/client';
import Modal from '../../lib/ui/Modal';
import { useState } from 'react';
import ButtonArea from '../../lib/forms/ButtonArea';
import ValidatedButton from '../../lib/forms/ValidatedButton';
import { Button, Form } from '@atrocit/scl';

export default function DeleteRelationModal({ isOpen, onClose, relationId, refetch }) {
	const [ loading, setLoading ] = useState(false);

	const [ deleteRelation ] = useMutation(gql`mutation Mutation($relationId: Int!) {
        deleteRelation(relationId: $relationId)
    }`);

	function process() {
		setLoading(true);
		deleteRelation({ variables: { relationId: relationId } }).finally(() => { refetch(); onClose(); });
	}

	return <Modal isOpen={isOpen} onClose={onClose} title="Relatie verwijderen">
		{!loading && <Form style={{ maxWidth: "var(--u-384)" }} onSubmit={process}>
			<p style={{ marginTop: 0 }}>Wilt u deze relatie verwijderen? Deze actie kan niet ongedaan gemaakt worden.</p>
			<ButtonArea>
				<ValidatedButton type="submit" style={{ background: "var(--col-red)", color: "var(--col-white)", borderColor: 'var(--col-red-600)' }}>
					<span className="fa fa-trash" />&nbsp;Verwijderen
				</ValidatedButton>
				<Button onClick={onClose}>Annuleren</Button>
			</ButtonArea>
		</Form>}
		{loading && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
			<span className="fa fa-spinner fa-pulse" style={{ fontSize: 'var(--fs-18)' }} />
		</div>}
	</Modal>;
}